import styles from './LiquidityHeader.module.css';
import { MdShowChart } from 'react-icons/md';
import { HiDotsHorizontal } from 'react-icons/hi';
import { FiSettings } from 'react-icons/fi';
import ContentHeader from '../misc/ContentHeader/ContentHeader';
const LiquidityHeader = () => {
  return (
    <ContentHeader>
      <span>{''}</span>
      <span className={styles.title}>Add Liquidity</span>
      <div className={styles.settings_container}>
        <HiDotsHorizontal />
        <FiSettings />
      </div>
    </ContentHeader>
  );
};

export default LiquidityHeader;
